import React from 'react'
import { IconX } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'

// A quiet dismiss pinned to an insight card's top-right corner. Dismissing only
// hides the card; it stops the click so the card doesn't also open the drawer.
// The wrapper carries the positioning: Button wraps itself in its own tooltip
// anchor, so positioning the button alone would leave the tooltip behind.
export const DismissInsightButton = ({ insightId, onDismiss }) => (
  <span className="dismiss-insight-button">
    <Button
      xs
      square
      basic
      tooltip="Dismiss"
      aria-label="Dismiss insight"
      onClick={(event) => {
        event.stopPropagation()
        onDismiss(insightId)
      }}
    >
      <IconX />
    </Button>
  </span>
)
